// extracted by mini-css-extract-plugin
export default {"list":"za","feature":"Aa","icon":"Ba","heading":"Ca","text":"Da","blinking":"Ea"};